import { Box, Fade, makeStyles, TextField, Typography } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { transitionTimeout } from '../ClaimWizard';
import { separations } from '../../../../constants/StyleConstants';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import SimpleKeyValueText from '../../../../components/UI/SimpleKeyValueText';
import clsx from 'clsx';
import { dateToStr } from '../../../../utils/DateUtils';
import ClaimsAPI from '../../../../services/ClaimsAPI';
import { AppContext } from '../../../../contexts/AppContext';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    '& .MuiOutlinedInput-multiline': {
      height: '100%',
      alignItems: 'flex-start',
    },
  },
  msgWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  msgBox: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: 4,
    whiteSpace: 'nowrap',
    maxWidth: '50%',
  },
  descriptionInput: {
    height: '100%',
    margin: 0,
  },
}));

const PurchaseOrdersClaim = ({ purchaseOrder }) => {
  const classes = useStyles();
  const { showError, showWarning } = useContext(AppContext);
  const { setStepElements, setOpenBackDrop, selectedClaimId } = useContext(ClaimContext);
  const [transIn, setTransIn] = useState(true);
  const [description, setDescription] = useState('');

  useEffect(() => {
    const step = {
      stepNumber: 2,
      backButtonText: purchaseOrder ? 'Cancelar y elegir otro pedido de compra' : 'Cancelar y Volver',
      finishButtonText: 'Iniciar reclamo',
      finishButtonAction: () => sendClaim(description),
      transition: {
        enter: () => setTransIn(true),
        exit: () => setTransIn(false),
      },
    };

    setStepElements(step.stepNumber, step);
  }, [description]);

  const handleChangeDescription = value => {
    if (value.isBlank()) {
      setDescription('');
    } else {
      setDescription(value);
    }
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = description.isBlank())) errorMessages.push('Debe ingresar una descripción');

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const sendClaim = () => {
    return new Promise((resolve, reject) => {
      if (validate()) {
        setOpenBackDrop(true);

        const request = {
          idType: selectedClaimId,
          description: description,
          additionalInfo: purchaseOrder ? { purchaseOrderCode: purchaseOrder.purchaseOrderCode } : undefined,
        };

        ClaimsAPI.startClaim(request)
          .then(res => {
            resolve();
          })
          .catch(error => {
            setOpenBackDrop(false);
            showError('Error al iniciar reclamo');
          });
      } else {
        reject();
      }
    });
  };

  return (
    <Fade in={transIn} timeout={transitionTimeout} unmountOnExit>
      <div className={classes.root}>
        <Typography className={classes.bottomSeparation} variant="subtitle2">
          {purchaseOrder
            ? 'Se iniciará el reclamo por el pedido de compra con los siguientes datos'
            : 'Se iniciará el reclamo por un pedido de compra inexistente'}
        </Typography>
        <div className={clsx(classes.msgWrapper, classes.separationBetween)}>
          {purchaseOrder && (
            <Box className={classes.msgBox} p={2}>
              <SimpleKeyValueText label="Nro. Pedido de compra" value={purchaseOrder.purchaseOrderCode} />
              <SimpleKeyValueText label="Fecha de pedido" value={dateToStr(purchaseOrder.purchaseOrderDate)} />
            </Box>
          )}
          <TextField
            className={classes.descriptionInput}
            fullWidth
            margin="dense"
            rows={purchaseOrder ? undefined : 6}
            rowsMax={20}
            id="description"
            multiline
            variant="outlined"
            label="Descripción"
            onChange={e => handleChangeDescription(e.target.value)}
            value={description}
          />
        </div>
      </div>
    </Fade>
  );
};

export default PurchaseOrdersClaim;
